import { ChatbotMembersPanel } from '../ChatbotMembersPanel';
import type { ChatbotMembership } from '../../../types/chatbot';

type ChatbotMembersTabProps = {
  chatbotId: string;
  chatbotName: string;
  members: ChatbotMembership[];
};

export function ChatbotMembersTab({
  chatbotId,
  chatbotName,
  members,
}: ChatbotMembersTabProps) {
  return (
    <ChatbotMembersPanel
      chatbotId={chatbotId}
      chatbotName={chatbotName}
      members={members}
    />
  );
}
